/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=5f61c081"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "H:\\高报云\\HZY\\Code\\集团官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__